export default __webpack_public_path__ + "static/media/design-thinking-phone.342c75a0.svg";